export const getBoardIdFromUrlOrEnvironment = (id?: string | undefined) => {
  if (process.env.VITE_LOCAL_BOARD_ID) {
    return process.env.VITE_LOCAL_BOARD_ID;
  }

  const location = globalThis.location;
  if (!location) {
    return id;
  }

  const url = new URL(location.href);

  const hash = url.hash;
  if (hash.includes('/whiteboard/')) {
    return hash.split('/whiteboard/').pop();
  }

  const path = url.pathname;
  if (path.includes('/whiteboard/')) {
    return path.split('/whiteboard/').pop();
  }

  return id;
};
